import {
  BrowserCacheLocation,
  IPublicClientApplication,
  InteractionType,
  LogLevel,
  PublicClientApplication,
} from '@azure/msal-browser';
import { environment } from '../environments/environment';
import {
  MsalGuardConfiguration,
  MsalInterceptorConfiguration,
} from '@azure/msal-angular';

export function loggerCallback(logLevel: LogLevel, message: string) {
  console.log(message);
}

// reusable INITIALIZED MSAL instance
let msalInstance: IPublicClientApplication | null = null;

export function MSALInstanceFactory(): IPublicClientApplication {
  if (!msalInstance) {
    msalInstance = new PublicClientApplication({
      auth: {
        clientId: environment.msalConfig.auth.clientId,
        authority: environment.msalConfig.auth.authority,
        redirectUri: '/home',
        postLogoutRedirectUri: '/login',
      },
      cache: {
        cacheLocation: BrowserCacheLocation.LocalStorage,
      },
      system: {
        allowPlatformBroker: false, // Disables WAM Broker
        loggerOptions: {
          // loggerCallback,
          logLevel: LogLevel.Info,
          piiLoggingEnabled: false,
        },
      },
    });
  }
  return msalInstance;
}

export async function initializeMsal(): Promise<void> {
  const instance = MSALInstanceFactory();
  await instance.initialize();

  try {
    await instance.handleRedirectPromise();
  } catch (error) {
    console.error('Error handling promise:', error);
  }
}

export function MSALInterceptorConfigFactory(): MsalInterceptorConfiguration {
  const protectedResourceMap = new Map<string, Array<string>>();
  protectedResourceMap.set(
    environment.apiConfig.uri,
    environment.apiConfig.scopes,
  );
  protectedResourceMap.set(
    environment.healthGuardApi.uri,
    environment.healthGuardApi.scopes,
  );
  const internalToolingUri = environment.internalToolingAPI.uri;

  protectedResourceMap.set(
    internalToolingUri,
    environment.internalToolingAPI.scopes,
  );
  protectedResourceMap.set(
    environment.blueCreekAPI.uri,
    environment.blueCreekAPI.scopes,
  );
  protectedResourceMap.set('https://graph.microsoft.com/v1.0/me', [
    'user.read',
  ]);

  return {
    interactionType: InteractionType.Redirect,
    protectedResourceMap,
  };
}

export function MSALGuardConfigFactory(): MsalGuardConfiguration {
  return {
    interactionType: InteractionType.Redirect,
    authRequest: {
      scopes: [...environment.apiConfig.scopes],
    },
    loginFailedRoute: '/login',
  };
}
